"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const withStore_1 = __importDefault(require("../../common/decorators/withStore"));
const apiService_1 = __importDefault(require("../../common/services/apiService"));
const Routes_1 = __importDefault(require("./Routes/Routes"));
const KioskIdleTimer_1 = __importDefault(require("./Reservations/KioskIdleTimer"));
const App = ({ currentLocale, userData, kioskModeEnabled }) => {
    const USER_ACTIVATION_DELAY_MS = 30000;
    const TOKEN_CREATED_AT_STORAGE_KEY = 'tokenCreatedAt';
    const [isLoaded, setIsLoaded] = (0, react_1.useState)(false);
    const fetchBrandAppkey = () => __awaiter(void 0, void 0, void 0, function* () {
        if (window.location.hostname !== 'localhost') {
            const brandKey = yield apiService_1.default.getBrandAppKey();
            sessionStorage.setItem('brandKey', brandKey);
        }
        setIsLoaded(true);
    });
    const activateUser = () => {
        const userToken = localStorage.getItem('userToken');
        if (!userToken) {
            return;
        }
        const tokenCreatedAtRaw = localStorage.getItem(TOKEN_CREATED_AT_STORAGE_KEY);
        const tokenCreatedAt = tokenCreatedAtRaw ? Date.parse(tokenCreatedAtRaw) : NaN;
        if (!Number.isFinite(tokenCreatedAt) || tokenCreatedAt <= 0) {
            apiService_1.default.activateUser(userToken);
            return;
        }
        const elapsedMs = Date.now() - tokenCreatedAt;
        const remainingMs = Math.max(USER_ACTIVATION_DELAY_MS - elapsedMs, 0);
        if (remainingMs === 0) {
            apiService_1.default.activateUser(userToken);
            return;
        }
        setTimeout(() => {
            apiService_1.default.activateUser(userToken);
        }, remainingMs);
    };
    const root = document.querySelector(':root');
    const addCssPropertyToRoot = () => {
        if (root) {
            root.style.setProperty('--vh', `${window.innerHeight / 100}px`);
        }
    };
    const cancelPaymentSession = () => {
        const storedPaymentReference = localStorage.getItem('paymentReference');
        const kioskUserToken = localStorage.getItem('kioskUserToken');
        const stationToken = localStorage.getItem('stationToken');
        if (storedPaymentReference) {
            apiService_1.default.cancelPaymentSesison(currentLocale, userData.token, storedPaymentReference, kioskModeEnabled, stationToken);
            if (kioskUserToken) {
                apiService_1.default.cancelPaymentSesison(currentLocale, kioskUserToken, storedPaymentReference, kioskModeEnabled, stationToken);
            }
            localStorage.setItem('paymentReference', '');
        }
    };
    (0, react_1.useEffect)(() => {
        if (currentLocale && Object.keys(userData).length !== 0) {
            cancelPaymentSession();
        }
    }, [currentLocale, userData]);
    (0, react_1.useEffect)(() => {
        fetchBrandAppkey();
        addCssPropertyToRoot();
        window.addEventListener('resize', addCssPropertyToRoot);
        return () => {
            if (root) {
                window.removeEventListener('resize', addCssPropertyToRoot);
            }
        };
    }, []);
    (0, react_1.useEffect)(() => {
        if (isLoaded) {
            activateUser();
        }
    }, [isLoaded]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        isLoaded ? (react_1.default.createElement(react_1.Suspense, { fallback: react_1.default.createElement(react_1.default.Fragment, null) },
            react_1.default.createElement(Routes_1.default, null))) : (''),
        kioskModeEnabled && react_1.default.createElement(KioskIdleTimer_1.default, null)));
};
const mapStoreToProps = store => ({
    currentLocale: store.getValue('currentLocale'),
    userData: store.getValue('userData'),
    kioskModeEnabled: store.getValue('kioskModeEnabled'),
});
exports.default = (0, withStore_1.default)(mapStoreToProps)(App);
